import { render, staticRenderFns } from "./CopyPermissionsModal.vue?vue&type=template&id=7f1369b0&"
import script from "./CopyPermissionsModal.vue?vue&type=script&lang=ts&"
export * from "./CopyPermissionsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports